import React from "react";
import { connect } from "react-redux";
import DashboardList from "../../Components/Layouts/DashboardList";
import { getList, deleteEntityById } from "../../Redux/Itinerary/actions";

function List({ useAuth, getList, list, onDelete}) {
  const tableConfig = {
    title: "Itineraries",
    filterOptionTitle: "Team Type",
    filterOptions: [
      "package",
    ],
    defaultFilterValue: 'admin',
    applyFilter: false,
    tableColumns: [
      {name: "Status", selector: 'status', width: '3%'},
      //{name: "Order", selector: 'order', width: '3%'},
      {name: "Title", selector: 'itinerary_title', width: '70%'},
      {name: "Modified Date", selector: 'updated_at', width: '20%'},
      {name: "ID", selector: 'id', width: '5%'}
    ],
    filterByColumn: 'title',
    searchByColumn: 'title',
    updatePath: "/itinerary/update", 
    addPath: "/itinerary/add",
    noDataMessage: "No Itinerary exists",
    updateLinkColumn: 'itinerary_title',
    deleteBtnText: 'Delete',
    deleteItemsByIdList: (idList) => {
      onDelete(idList)
    },
  }

  return (
    <DashboardList
      useAuth={useAuth}
      getList={getList}
      dataToList={list}
      tableConfig={tableConfig}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    list: state.itineraries,  
    loginData: state.loginData, 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getList: (tokenData) => dispatch(getList(tokenData)),
    onDelete: (idList) => dispatch(deleteEntityById(idList))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
